const TOKEN_KEY = "Authorization";

function getToken(): string {
  return localStorage.getItem("TOKEN") || "";
}

function setToken(token: string) {
  return localStorage.setItem(TOKEN_KEY, token);
}

function clearToken() {
  return localStorage.removeItem(TOKEN_KEY);
}

export { getToken, setToken, clearToken };
